exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".btn-clicked{background-color:#bfbfbf!important}.btn-selection{color:#000;-webkit-text-shadow:0 -1px 0 rgba(0,0,0,.25);text-shadow:0 -1px 0 rgba(0,0,0,.25);background-color:#fdf8d1;text-transform:uppercase}.footer-question{font-size:12px}.corCinzaClaro{background-color:#efefef;border:1px solid #ddd}.corDisable{background-color:#f7eb98;border:1px solid #ddd;color:#a9a4a4}.linhaBottom{border-bottom:1px solid #ccc}.linhaTop{border-top:1px solid #ccc}.question .btn-block{padding:10px}.texto-passo{color:#a9a4a4;text-transform:uppercase;text-align:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/app/components/views/question/question.style.scss
// module id = 785
// module chunks = 0